import React, { Component } from 'react';

import ErrorPage from './ErrorPage';
import SignInWithSlackButton from './SignInWithSlackButton';

export default class ErrorPageRequiresAuthentication extends Component {
  render() {
    return (
      <ErrorPage
        pageTitle="Requires Sign In"
        subtitle="To view this page, sign in via Slack."
        title="Oops! You’re not signed in."
      >
        <div className="mt4 tc">
          <SignInWithSlackButton />
        </div>
      </ErrorPage>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/ErrorPageRequiresAuthentication.jsx
 **/